<template>
  <div class="form_add_page" v-loading="isLoading">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $route.query.operate }}
      </div>

      <div class="button_list flex-right">
        <zip-btn
          :name="claimantInfo.claimStatementNum"
          v-show="fileList && fileList.length > 0"
          :fileList="fileList"
        />
        <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          size="mini"
          type="primary"
          @click="getNextData('noExamine')"
          >下一条</el-button
        >
      </div>
    </div>
    <detail
      v-if="formLoading"
      ref="detailRef"
      :claimantInfo.sync="claimantInfo"
      :previewFile="previewList"
    />
    <div
      slot="footer"
      style="text-align:center"
      v-if="formLoading && $route.query.operate === '确认金额'"
    >
      <el-button class="lang-but" type="primary" @click="handleExamine(1)">确定</el-button>
      <el-button class="lang-but" type="primary" plain @click="back">取消</el-button>
    </div>
    <!-- 审核完成弹窗 -->
    <el-dialog
      :visible.sync="showComplete"
      width="420px"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      center
    >
      <div style="text-align: center; width: 100%">
        <i
          class="el-icon-warning-outline"
          style="color: #E99D42; margin-right: 13px"
        />{{ completeTip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="getNextData"
          >下一条</el-button
        > -->
        <el-button
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="back"
          >返回列表</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {kdconfirmAmount,kdgetClimantDetail1, kdfillSecondList} from "@/api/seek";
import { setStorage } from "@/util/localStor";
import Detail from "./components/detail.vue";
import zipBtn from "@/components/downloadZip";

export default {
  components: { Detail, zipBtn },
  data() {
    return {
      showComplete: false, // 审核完成弹窗
      completeTip: "", // 审核完成提示
      completeBtn: false, // 审核完成弹窗按钮状态
      isLoading: false, // 页面加载状态
      claimantInfo: {}, // 表单数据
      formLoading: false,
      fileList:[],
      previewList:[],
    };
  },
  watch: {},
  computed: {
    // 表单验证规则
    rules() {
      return {};
    }
  },
  created() {},
  async mounted() {
    if (this.$route.query?.claimantId) {
      this.isLoading = true;
      const res = await kdgetClimantDetail1(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        this.fileList = this.claimantInfo.faultPartsList?.reduce((acc, item) => {
            if (item.fileList && item.fileList.length > 0) {
              acc.push(...item.fileList);
            }
          return acc;
        }, []);
        this.previewList = this.fileList?.filter(item => {
          return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
        });
        // 将二赔金额为空时处理，避免为空时显示0
        if (
          this.claimantInfo.faultPartsList &&
          this.claimantInfo.faultPartsList.length > 0
        ) {
          this.claimantInfo.faultPartsList.map(v=>{

            if (v.responsibilityPartList&&
              v.responsibilityPartList.length > 0){
              v.responsibilityPartList.map((item, index) => {
                item.secondDamages =
                  item.secondDamages ?? undefined;
              });
            }

          })
        }
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    }
    this.$nextTick(() => {
      this.formLoading = true;
    });
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.isLoading = true;
      const res = await kdgetClimantDetail1(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        this.fileList = this.claimantInfo.faultPartsList?.reduce((acc, item) => {
            if (item.fileList && item.fileList.length > 0) {
              acc.push(...item.fileList);
            }
          return acc;
        }, []);
        this.previewList = this.fileList?.filter(item => {
          return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
        });
        // 将二赔金额为空时处理，避免为空时显示0
        if (
          this.claimantInfo.faultPartsList &&
          this.claimantInfo.faultPartsList.length > 0
        ) {
          this.claimantInfo.faultPartsList.map(v=>{
            if (v.responsibilityPartList&&
              v.responsibilityPartList.length > 0){
              v.responsibilityPartList.map((item, index) => {
                item.secondDamages =
                  item.secondDamages ?? undefined;
              });
            }

          })
        }
        this.$nextTick(() => {
          this.formLoading = true;
        });
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 审核
    async secondAudit(secondClaimStatus, remark) {
     let newResponsibilityPartList=[]
        this.claimantInfo.faultPartsList.map(v=>{
          if (v.responsibilityPartList&&
            v.responsibilityPartList.length > 0){
            v.responsibilityPartList.map(item=>{
              item.faultPartId = v.faultPartId
              newResponsibilityPartList.push(item)
            })

          }
        })

      const submitData = {
        claimStatementId: this.claimantInfo.claimStatementId,
        responsibilityPartList: newResponsibilityPartList,
        secondClaimStatus: secondClaimStatus,
        remark: remark
      };
      this.isLoading = true;
      try {
        var res = await kdconfirmAmount({ data: submitData });
        if (res.status == 0) {
          this.isLoading = false;
          this.completeTip = `索赔订单 ${this.claimantInfo.claimStatementId} 已确认二次索赔金额`;
          this.showComplete = true;
        } else {
          this.isLoading = false;
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        this.isLoading = false;
      }
    },
    // 点击审核
    async handleExamine(type) {
      if (type == 1) {
        this.secondAudit(2);
      }
    },
    // 下一条
    async getNextData(type) {
      this.completeBtn = true;
      let query = JSON.parse(this.$route.query?.searchObj);
      if (type === "noExamine") {
        this.isLoading = true;
        query.page.pageNum = query.page.pageNum + 1;
      }
      const res = await kdfillSecondList(query);
      if (res.status == 0) {
        this.completeBtn = false;
        this.isLoading = false;
        this.showComplete = false;
        if (
          res.data.records[0] &&
          res.data.records[0].secondClaimStatus === 1 &&
          res.data.records[0].status !== 13
        ) {
          setStorage("claimantData", res.data.records[0]);
          this.$router.replace({
            path: "/kd-claimant/secondCompensationFillDetail",
            query: {
              claimantId: res.data.records[0].claimStatementId,
              searchObj: JSON.stringify({
                ...query
              }),
              enableNext: this.$route.query?.enableNext,
              operate: this.$route.query?.operate
            }
          });
          this.getDetailData();
        } else {
          this.$DonMessage.warning("筛选索赔单已审核完！");
        }
      } else {
        this.completeBtn = false;
        this.isLoading = false;
        this.$DonMessage.error(res.message);
      }
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.form_add_page {
  // margin-top: 15px;
  padding-bottom: 20px;
  .form_info {
    ::v-deep .el-input {
      // width: 250px;
    }
  }
  ::v-deep .el-table__body .el-input {
    width: unset;
  }
  ::v-deep .el-textarea__inner {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
    // padding: 0 60px;
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
    // p {
    //   font-size: 14px;
    //   line-height: 20px;
    // }
    // span {
    //   font-size: 12px;
    //   line-height: 16px;
    // }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
    .table-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text-btn {
        cursor: pointer;
        color: #4084ff;
        padding: 0;
        font-size: 14px;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .fanyi-box {
    padding-left: 50px;
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
}
.file {
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
